import { ContextRouterAction, ContextRouterActions } from './ContextRouterState.model';

export function validate(urlKey: string, authKey: string): ContextRouterAction {
  return {
    type: ContextRouterActions.VALIDATE_CONTEXT_ROUTER,
    payload: { urlKey: urlKey, authKey: authKey },
  };
}

export function validateSuccess(response: any): ContextRouterAction {
  return {
    type: ContextRouterActions.VALIDATE_CONTEXT_ROUTER_SUCCESS,
    payload: response,
  };
}

export function validateFail(error: string): ContextRouterAction {
  return {
    type: ContextRouterActions.VALIDATE_CONTEXT_ROUTER_FAIL,
    payload: error,
  };
}

export function updateAuthToken(authKey: string): ContextRouterAction {
  return {
    type: ContextRouterActions.UPDATE_CONTEXT_ROUTER_AUTHKEY,
    payload: authKey,
  };
}

export function setThemeOpCo(opcoTheme: string): ContextRouterAction {
  return {
    type: ContextRouterActions.SET_OPCO_THEME,
    payload: opcoTheme,
  };
}
